import './layout.css';
import { Outlet, useLocation } from "react-router-dom";
import NavigationComponent from "../navigation/navigation.component";
import FooterComponent from "../footer/footer.component";
import HomeComponent from "../../pages/home/home.component";

const LayoutComponent = (): JSX.Element => {
	const { pathname } = useLocation();
  
  return <>
    <header>
        <NavigationComponent />
    </header>
    <main>
			{
				pathname === '/' 
					? <HomeComponent />
					: <Outlet />
			}
    </main>
    <FooterComponent />
  </>
}

export default LayoutComponent
